import React, { useEffect, useState } from "react";

/**
 * Inline PDF viewer for a local File from the invoice upload flow.
 * Uses createObjectURL — data: URLs break for many PDFs in Chromium iframes.
 */
export default function DisplayPdf({ pdfFile }) {
    const [pdfUrl, setPdfUrl] = useState("");

    useEffect(() => {
        if (!pdfFile) {
            setPdfUrl("");
            return undefined;
        }
        const url = URL.createObjectURL(pdfFile);
        setPdfUrl(url);
        return () => {
            URL.revokeObjectURL(url);
        };
    }, [pdfFile]);

    if (!pdfFile) {
        return (
            <div style={{ width: "100%", height: "90vh", display: "grid", placeItems: "center" }}>
                No PDF to display.
            </div>
        );
    }

    if (!pdfUrl) {
        return (
            <div style={{ width: "100%", height: "90vh", display: "grid", placeItems: "center" }}>
                Loading preview…
            </div>
        );
    }

    return (
        <div style={{ width: "100%", height: "90vh" }}>
            <iframe
                src={pdfUrl}
                width="100%"
                height="100%"
                style={{ border: "none" }}
                title="PDF Viewer"
            />
        </div>
    );
}
